import { useState } from "react";
import SupportHero from "./SupportHero";
import TicketModal from "./TicketModal";

export default function SupportPage() {
  const [open, setOpen] = useState(false);
  return (
    <div className="min-h-screen bg-white">
      <SupportHero onOpenTicket={() => setOpen(true)} />

      <div className="px-6 pb-16 mx-auto max-w-6xl">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div className="p-5 bg-emerald-50 rounded-2xl border border-emerald-600/20">
            <h3 className="text-sm font-semibold text-emerald-900">Response times</h3>
            <p className="mt-1 text-xs text-emerald-900/80">Most tickets are answered within 24 hours.</p>
          </div>
          <div className="p-5 bg-emerald-50 rounded-2xl border border-emerald-600/20">
            <h3 className="text-sm font-semibold text-emerald-900">Knowledge base</h3>
            <p className="mt-1 text-xs text-emerald-900/80">Visit the Help Center for instant answers.</p>
          </div>
        </div>
      </div>

      <TicketModal open={open} onClose={() => setOpen(false)} onSubmit={(data) => console.log("ticket:", data)} />
    </div>
  );
}


